<template>
    <div class="blog spacer">
    <vue-headful
        title="Fedsight Blog"
        description="Learn about topics from hubzones, Qlik development, Qlik development strategies, and more in the new Fedsight blog."
    />
        <section class='container-fluid blogHero d-flex align-items-center justify-content-center'>
            <p class='slogan internalHeader'></p>
        </section>

        <section class='mainParagraph'>
            <div class='container'>
                <h1 class='fedsightGreen'>Fedsight Blog</h1>
                <p>Review the topics below and if you have any questions or would like to have a certain topic covered feel free to contact us using one of the contact methods in the footer of the page.</p>
            </div>
        </section>

        <section>
            <div class='container'>
                   <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>Topic</th>
                        <th>Date Added</th>
                        <th>Link</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class='blogTopicRow'>
                        <td>Why Working With a HUBZone Certified Contractor Matters</td>
                        <td>1/15/2020</td>
                        <td><router-link to="/Why-Choose-Hubzone-Certified-Companies" target='_blank'><p>Go to HUBZone Topic</p></router-link></td>
                    </tr>
                    <tr class='blogTopicRow'>
                        <td>Qlik Sense Mashups</td>
                        <td>1/30/2020</td>
                        <td><router-link to="/Qlik-Sense-Mashups" target='_blank'><p>Go to Mashup Topic</p></router-link></td>
                    </tr>
                    <tr class='blogTopicRow'>
                        <td>Why Qlik Sense</td>
                        <td>6/2/2020</td>
                        <td><router-link to="/Why-Qlik-Sense" target='_blank'><p>Go to Qlik Sense Topic</p></router-link></td>
                    </tr>
                    <tr class='blogTopicRow'>
                        <td>What goes into a Qlik Sense Executive View</td>
                        <td>coming soon</td>
                        <td><router-link to="" target='_blank'><p></p></router-link></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'blog',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/blog'}
      ]
    },
    mixins: [closeMenu],
    mounted() {
      document.dispatchEvent(new Event('page.rendered'));
    }
}

</script>

<style scoped>
.blogHero{
    height: 30rem;
    background-image: url(../../assets/about-hero-large.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.blogHeader{
    color: #fff;
    font-size: 6rem;
}
.mainParagraph{
    padding: 8rem 1.5rem;
    max-width: 80rem;
    margin: auto;
}
td{
    text-align: left;
}
.blogTopicRow:hover{
  background-color: #eee;
}

/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
    .blogHero{
      background-image: url(../../assets/about-hero-small.jpg);
    }
  }

  @media (min-width: 576px) { 
    .blogHero{
      background-image: url(../../assets/about-hero-small.jpg);
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    .blogHero{
      justify-content: center !important;
      background-position: left bottom;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) { 
    .blogHero{
      background-image: url(../../assets/about-hero-medium.jpg);
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) { 
    .blogHero{
      background-image: url(../../assets/about-hero-large.jpg);
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>